import axios from 'axios';

// Get clean host port dynamically or fallback to localhost:8000
const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const cleanPort = isLocal ? 'http://localhost:8000' : `${window.location.protocol}//hrmbackendapi.${window.location.hostname.replace('hrm.', '')}`;
const API_BASE_URL = `${cleanPort}/api/wa`;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor to inject employee ID header from sessionStorage for HRM SSO auth
apiClient.interceptors.request.use((config) => {
  // Read HRM user from session storage
  const hrmUser = sessionStorage.getItem('user');
  if (hrmUser) {
    try {
      const parsed = JSON.parse(hrmUser);
      if (parsed && parsed.EmployeeId) {
        config.headers['X-HRM-Employee-ID'] = parsed.EmployeeId;
      }
    } catch (e) {
      console.error('Error parsing HRM user from session storage', e);
    }
  }

  // Inject WhatsApp config ID if selected (used by middleware)
  const activeConfigId = localStorage.getItem('activeWhatsAppConfigId');
  if (activeConfigId) {
    config.headers['X-WhatsApp-Config-ID'] = activeConfigId;
  }

  return config;
});

// Simple response interceptor that returns data or errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export const getApiErrorMessage = (error, fallback = 'Something went wrong') => {
  const data = error?.response?.data;
  if (data) {
    if (typeof data.error === 'string') return data.error;
    if (data.message) return data.message;
    if (data.details) {
      if (typeof data.details === 'string') return data.details;
      if (Array.isArray(data.details)) return JSON.stringify(data.details);
      if (typeof data.details === 'object') return data.details.message || JSON.stringify(data.details);
    }
    
    // Parse Django serializer field-specific validation dictionary errors
    if (typeof data === 'object' && !Array.isArray(data)) {
      const fieldErrors = [];
      Object.entries(data).forEach(([key, val]) => {
        // Skip keys that aren't specific field validation arrays/strings
        if (key === 'error' || key === 'message' || key === 'details') return;
        
        // Capitalize field name prefix for user presentation
        const fieldPrefix = key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ');
        if (Array.isArray(val)) {
          fieldErrors.push(`${fieldPrefix}: ${val.join(', ')}`);
        } else if (typeof val === 'string') {
          fieldErrors.push(`${fieldPrefix}: ${val}`);
        } else if (typeof val === 'object') {
          fieldErrors.push(`${fieldPrefix}: ${JSON.stringify(val)}`);
        }
      });
      if (fieldErrors.length > 0) {
        return fieldErrors.join(' | ');
      }
    }
  }
  return error.message || fallback;
};

export default apiClient;
